// Widget: Heute fällig — offene Tasks (Projekt + persönlich) mit Due = heute.

import { useEffect, useState } from "preact/hooks";
import { useLocation } from "wouter-preact";
import { CalendarClock } from "lucide-preact";
import { fetchMyOpenTasks, type DashboardTaskItem } from "../../lib/dashboardTasks";
import { localTodayIso } from "../../lib/format";

export function TodayWidget(): preact.JSX.Element {
  const [tasks, setTasks] = useState<DashboardTaskItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [, setLocation] = useLocation();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    const today = localTodayIso();
    void fetchMyOpenTasks().then(
      (items) => {
        if (cancelled) return;
        setTasks(items.filter((t) => t.due === today));
        setLoading(false);
      },
      () => {
        // Sonst blieb ein Ladefehler unsichtbar hinter "Heute nichts fällig." —
        // ein leerer Erfolg sieht identisch aus wie ein Fehlschlag, ohne
        // diesen eigenen Zustand.
        if (cancelled) return;
        setError(true);
        setLoading(false);
      }
    );
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading)
    return <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">Lädt…</p>;
  if (error)
    return (
      <p class="text-xs text-[color:var(--color-error)] italic">
        Konnte nicht geladen werden.
      </p>
    );
  if (tasks.length === 0)
    return (
      <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">
        Heute nichts fällig.
      </p>
    );

  return (
    <ul class="flex flex-col gap-1.5 text-sm">
      {tasks.map((t) => (
        <li key={t.uid}>
          <button
            type="button"
            onClick={() => setLocation(t.href)}
            class="w-full flex items-center gap-2 text-left rounded px-1.5 py-1 hover:bg-[color:var(--color-surface-container-low)]"
          >
            <CalendarClock
              size={14}
              class="text-[color:var(--color-primary)] shrink-0"
            />
            <span class="flex-1 min-w-0 truncate">{t.title}</span>
            <span class="text-label text-[color:var(--color-on-surface-variant)]">
              {t.sourceLabel}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
